'use client'

import { useContext } from 'react'

import { Button, Cell, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { GetShippingLabelContext } from '@marketplace-web/shipping-services-provider/shipping-services-provider-feature'

import { isReusablePackagingFlowEnabled, isDropOffTypeFlow } from '../../utils'

type Props = {
  handleModalClose: () => void
  onConfirmationOpen: () => void
  onGenerateLabelClick: () => void
  isShippingLabelLoading: boolean
}

const DialogSubmit = ({
  handleModalClose,
  onConfirmationOpen,
  isShippingLabelLoading,
  onGenerateLabelClick,
}: Props) => {
  const {
    state: {
      labelOptions: { labelOptions, labelOptionsRewrite },
    },
  } = useContext(GetShippingLabelContext)

  const translate = useTranslate('conversation.get_shipping_label.modal')

  const labelOptionsData = labelOptionsRewrite || labelOptions

  const termsAndConditionsText = labelOptionsData?.carrier?.termsAndConditions
  const buttonText = labelOptionsData?.actionTitle

  const renderSubmitNote = () => {
    return (
      <Text
        as="h4"
        type={Text.Type.Caption}
        text={termsAndConditionsText || translate('generate_label_footnote')}
        html={!!termsAndConditionsText}
      />
    )
  }

  const handleConfirmationClick = () => {
    if (labelOptionsRewrite) return onGenerateLabelClick()

    return onConfirmationOpen()
  }

  return (
    <Cell>
      <Cell styling={Cell.Styling.Tight}>
        {renderSubmitNote()}
        <Spacer size={Spacer.Size.Large} />
        {isDropOffTypeFlow(undefined, labelOptions) &&
        !isReusablePackagingFlowEnabled(labelOptions, labelOptionsRewrite) ? (
          <>
            <Button
              styling={Button.Styling.Filled}
              text={buttonText}
              onClick={handleConfirmationClick}
              testId="get-label-modal-confirm"
              isLoading={isShippingLabelLoading}
              disabled={isShippingLabelLoading}
            />
            <Spacer />
            <Button
              styling={Button.Styling.Flat}
              text={translate('actions.cancel')}
              onClick={handleModalClose}
              testId="get-label-modal-cancel"
            />
          </>
        ) : (
          <Button
            styling={Button.Styling.Filled}
            text={buttonText}
            onClick={onGenerateLabelClick}
            testId="get-label-modal-generate"
            isLoading={isShippingLabelLoading}
            disabled={isShippingLabelLoading}
          />
        )}
      </Cell>
    </Cell>
  )
}

export default DialogSubmit
